import { Injectable } from '@angular/core';

import Feature from 'ol/Feature';
import Point from 'ol/geom/Point';
import LineString from 'ol/geom/LineString';
import MultiLineString from 'ol/geom/MultiLineString';
import Polygon from 'ol/geom/Polygon';
import MultiPolygon from 'ol/geom/MultiPolygon';
import MultiPoint from 'ol/geom/MultiPoint';
import {isNumber} from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class SclAssetLayersService {

  constructor() { }

  getAssetPoint(customData, fieldData, typeAsset, geoJsonField, primaryAssetAddressSelection) {
    let name = '';
    if (customData.systemHeader.summaryName) {
      name = customData.systemHeader.summaryName;
    } else {
      name = customData.assetId;
    }
    const id = customData.documentId;
    const propertiesLinkAsset = {
      documentId: id,
      name
    };
    const asset: any = {
      type: 'Feature',
      properties : {
        type: typeAsset,
        linkAssets: []
      }
    };
    if (!id) {
      return '';
    }
    if (primaryAssetAddressSelection && geoJsonField && customData[geoJsonField]) {
      const pointFeature = customData[geoJsonField].features[0];
      asset.street = {};
      asset.street.geometry = {
        type : 'Point',
        coordinates : pointFeature.geometry.coordinates
      };
      asset.street.properties = pointFeature.properties;
    }
    const relatedFields = fieldData.relatedFields;
    if (relatedFields) {
      for (const field in relatedFields) {
        if (relatedFields.hasOwnProperty(field)) {
          const fieldAsset = relatedFields[field];
          const value = customData[fieldAsset];
          if (value) {
            propertiesLinkAsset[field] = value;
          }
        }
      }
    }
    asset.properties.linkAssets.push(propertiesLinkAsset);
    return asset;
  }
  getGeometryAssetPoint(customData, fieldData, geoJsonField, primaryAssetAddressSelection) {
    let name = '';
    if (customData.systemHeader.summaryName) {
      name = customData.systemHeader.summaryName;
    } else {
      name = customData.assetId;
    }
    const id = customData.documentId;
    const propertiesLinkAsset = {
      documentId: id,
      name
    };
    const asset: any = {
      type: 'Feature',
      properties : {
        type: 'primaryAsset',
        linkAssets: []
      }
    };
    if (!id) {
      return '';
    }
    if (primaryAssetAddressSelection && geoJsonField) {
      if (customData[geoJsonField]) {
        const pointFeature = customData[geoJsonField].features[0];
        asset.street = {};
        asset.street.geometry = {
          type : 'Point',
          coordinates : pointFeature.geometry.coordinates
        };
        asset.street.properties = pointFeature.properties;
      }
    }
    const relatedFields = fieldData.relatedFields;
    if (relatedFields) {
      for (const field in relatedFields) {
        if (relatedFields.hasOwnProperty(field)) {
          const fieldAsset = relatedFields[field];
          const value = customData[fieldAsset];
          if (value) {
            propertiesLinkAsset[field] = value;
          }
        }
      }
    }
    asset.properties.linkAssets.push(propertiesLinkAsset);
    return asset;
  }
  getAssetProperties(feature, relatedFields, coordinates, typeAsset, typeSelection?) {
    let name = '';
    let id = '';
    if (feature.getProperties()) {
      name = feature.getProperties().name;
      id = feature.getProperties().id;
    }

    const propertiesLinkAsset = {
      documentId: id,
      name
    };
    const asset: any = {
      type: 'Feature',
      properties : {
        type: typeAsset,
        linkAssets: []
      }
    };
    if (!typeSelection || typeSelection === 'featureCollection') {
      asset.geometry = {
        type : 'Point',
        coordinates
      };
    }

    if (!id) {
      return '';
    }
    if (relatedFields) {
      for (const field in relatedFields) {
        if (relatedFields.hasOwnProperty(field)) {
          const value = feature.getProperties()[field];
          if (value) {
            propertiesLinkAsset[field] = value;
          }
        }
      }
    }
    asset.properties.linkAssets.push(propertiesLinkAsset);
    return asset;
  }
  getAssetPropertiesSelection(feature, relatedFields, coordinates, typeAsset, typeSelection) {
    let name = '';
    let id = '';
    if (feature.getProperties()) {
      name = feature.getProperties().name;
      id = feature.getProperties().id;
    }

    const propertiesLinkAsset = {
      documentId: id,
      name
    };
    const asset: any = {
      type: 'Feature',
      properties : {
        type: typeAsset,
        linkAssets: []
      }
    };
    if (!typeSelection || typeSelection === 'featureCollection') {
      asset.geometry = {
        type : 'Point',
        coordinates
      };
    }

    if (!id) {
      return '';
    }
    if (!typeSelection || typeSelection === 'featureCollection') {
      if (relatedFields) {
        for (const field in relatedFields) {
          if (relatedFields.hasOwnProperty(field)) {
            propertiesLinkAsset[field] = relatedFields[field];
          }
        }
      }
    }
    asset.properties.linkAssets.push(propertiesLinkAsset);
    return asset;
  }
  createSelectionObject(title, icon, anchor) {
    const selection: any = {};
    selection.imageAnchor = anchor;
    selection.imageFileNo = icon;
    selection.selectionType = 'multiple';
    selection.uiLabel = title;
    selection.relatedVisible = true;
    selection.selectionOutput = 'documentCollection';
    return selection;
  }
  getRelatedFieldSelection(feature, type) {
    const relatedFields = {};
    const pro = feature.getProperties();
    let fields = [];
    if (type == 'primary') {
      fields = pro.primaryFields;
    } else {
      fields = pro.secondaryFields;
    }
    if (fields) {
      for (const field in fields) {
        if (fields[field]) { relatedFields[field] = fields[field]; }
      }
    } else {
      for (const field in pro.mainFields) {
        if (pro.mainFields[field]) { relatedFields[field] = pro.mainFields[field]; }
      }
    }
    return relatedFields;
  }
  removeUnselectedAsset(assets, unSelectedAssetIds, type) {
     for (let i = 0; i < unSelectedAssetIds.length; i++) {
      const priAsset = unSelectedAssetIds[i];
      for (let j = 0; j < assets.length; j++) {
        const id = assets[j].properties.linkAssets[0].documentId;
        if (id === priAsset) {
          console.log('TODO sort out the missing sourceVector variable');
          // sclUtilMap.removeItemFromMap(id + '_' + type, sourceVector);
          // assets.splice(j, 1);
        }
      }
    }
  }
  removeUnselectedAssetItem(existAsset, assets, type) {
    if (existAsset) {
      for (let j = 0; j < assets.length; j++) {
        const item = assets[j];
        const id = item.properties.linkAssets[0].documentId + '_' + type;
        if (id === existAsset.properties.linkAssets[0].documentId) {
          console.log('TODO sort out the missing sourceVector variable');
          // sclUtilMap.removeItemFromMap(id, sourceVector);
          // assets.splice(j, 1);
          return true;
        }
      }
    }
    return false;
  }
  getPointFeature(location , image, name, id, relatedAsset, color, layerDisplayOnly, tooltip, anchor, type, layerName, url) {
    const graphPoint = new Feature(new Point(location));
    const properties: any = {
      icon : image,
      name,
      id
    };
    if (color) {properties.color = color; }
    if (tooltip) {properties.tooltip = tooltip; }
    if (layerDisplayOnly) {properties.layerDisplayOnly = layerDisplayOnly; }
    if (type) {properties.type = type; }
    if (anchor) {properties.anchor = anchor; }
    if (layerName) {properties.layerName = layerName; }
    if (url) {properties.url = url; }
    if (relatedAsset) {
      for (const field in relatedAsset) {
        if (relatedAsset.hasOwnProperty(field)) {
          const value = relatedAsset[field];
          properties[field] = value;
        }
      }
    }
    graphPoint.setProperties(properties);
    return graphPoint;
  }
  parseToLine(coor, id, toEPSG) {
    const feature = new Feature(new LineString(coor));
    const geom = feature.getGeometry().transform('EPSG:4326', toEPSG);
    feature.setId(id);
    return feature;
  }
  parseToMultiLine(coor, id, toEPSG) {
    const feature = new Feature(new MultiLineString(coor));
    const geom = feature.getGeometry().transform('EPSG:4326', toEPSG);
    feature.setId(id);
    return feature;
  }
  parseToPolygon(coor, id, toEPSG) {
    const feature = new Feature(new Polygon(coor));
    const geom = feature.getGeometry().transform('EPSG:4326', toEPSG);
    feature.setId(id);
    return feature;
  }
  parseToMultiPolygon(coor, id, toEPSG) {
    const feature = new Feature(new MultiPolygon(coor));
    const geom = feature.getGeometry().transform('EPSG:4326', toEPSG);
    feature.setId(id);
    return feature;
  }
  parseToPoint(coor, id, toEPSG) {
    const feature = new Feature(new Point(coor));
    const geom = feature.getGeometry().transform('EPSG:4326', toEPSG);
    feature.setId(id);
    return feature;
  }
  parseToMultiPoint(coor, id, toEPSG) {
    const feature = new Feature(new MultiPoint(coor));
    const geom = feature.getGeometry().transform('EPSG:4326', toEPSG);
    feature.setId(id);
    return feature;
  }
  parseAssetsFromFeatures(features, assetField, coor, typeAsset) {
    const assets = [];
    for (let i = 0; i < features.length; i++) {
      const asset = this.getAssetProperties(features[i], assetField.relatedFields, coor, typeAsset);
      if (!asset) {return; }
      assets.push(asset);
    }
    return assets;
  }
  isContainFeature(id, assets) {
    if (!assets) { return false; }
    for (let i = 0; i < assets.length; i++) {
      const ass = assets[i];
      if (ass.properties.linkAssets[0].documentId === id) { return true; }
    }
    return false;
  }
  createFeatureByType(coordinates, type, EPSG, id) {
    let feature;
    if (type === 'Point') {
      feature = this.parseToPoint(coordinates, id, EPSG);
    } else if (type === 'MultiPoint') {
      feature = this.parseToMultiPoint(coordinates, id, EPSG);
    } else if (type === 'LineString') {
      feature = this.parseToLine(coordinates, id, EPSG);
    } else if (type === 'MultiLineString') {
      feature = this.parseToMultiLine(coordinates, id, EPSG);
    } else if (type === 'Polygon') {
      feature = this.parseToPolygon(coordinates, id, EPSG);
    } else if (type === 'MultiPolygon') {
      feature = this.parseToMultiPolygon(coordinates, id, EPSG);
    }

    return feature;
  }
  createLineProperties(layer, name, color, id, popup, primaryMultiPopup,
                       secondaryMultiPopup, layerDisplayOnly, relatedAsset, url) {
    const isDashedLine = (layer && layer.lineDash !== undefined && layer.lineDash instanceof Array &&
      layer.lineDash.length > 0);
    let lineWidth = 4;
    if (layer && isNumber(layer.lineWidth)) {lineWidth = layer.lineWidth; }
    let lineDash = isDashedLine ? layer.lineDash : undefined;
    if (layer && isDashedLine) {lineDash = layer.lineDash; }
    let lineCap = 'round';
    if (layer && layer.lineCap) {lineCap = layer.lineCap; }

    const properties: any = {};
    if (name) {properties.name = name; }
    if (color) {properties.color = color; }
    if (id) {properties.id = id; }
    if (popup) {properties.tooltip = popup; }
    if (url) {properties.url = url; }
    if (primaryMultiPopup) {properties.primaryMultiPopup = primaryMultiPopup; }
    if (secondaryMultiPopup) {properties.secondaryMultiPopup = secondaryMultiPopup; }
    if (lineWidth) {properties.lineWidth = lineWidth; }
    if (lineDash) {properties.lineDash = lineDash; }
    if (lineCap) {properties.lineCap = lineCap; }
    if (layerDisplayOnly) { properties.layerDisplayOnly = layerDisplayOnly; }
    if (layer && layer.fill) { properties.fillColor = layer.fill; }
    if (layer && isNumber(layer.fillOpacity)) { properties.fillOpacity = layer.fillOpacity; }
    if (relatedAsset) {
      for (const field in relatedAsset) {
        if (relatedAsset[field]) {properties[field] = relatedAsset[field]; }
      }
    }

    return properties;
  }

}
